import { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";

export const AddressInput = ({ value, onChange, onPick, sicily, city, enabled, inputProps }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const typed = useRef(false);

  useEffect(() => {
    if (!enabled || !typed.current || value.trim().length < 4) { setItems([]); return undefined; }
    const t = setTimeout(() => {
      api.get("/shipping/address-suggest", { params: { q: value, sicily, city } }).then((r) => { setItems(r.data); setOpen(true); }).catch(() => setItems([]));
    }, 400);
    return () => clearTimeout(t);
  }, [value, sicily, city, enabled]);

  const pick = (it) => { typed.current = false; setOpen(false); setItems([]); onPick(it); };

  return (
    <div className="relative">
      <input {...inputProps} value={value} placeholder="es. Via Liguria 22" autoComplete="off"
        onChange={(e) => { typed.current = true; onChange(e.target.value); }}
        onFocus={() => items.length && setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && items.length > 0 && (
        <ul className="absolute left-0 right-0 top-full z-30 mt-1 overflow-hidden rounded-xl border-2 border-black bg-white shadow-lg" data-testid="address-suggestions">
          {items.map((it, i) => (
            <li key={`${it.address}-${it.zip}-${i}`}>
              <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => pick(it)} data-testid={`address-suggestion-${i}`}
                className="flex w-full items-start gap-2 px-4 py-2.5 text-left text-sm transition-colors hover:bg-amber-50">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
                <span><b>{it.address}</b><span className="block text-xs text-stone-500">{[it.zip, it.city, it.province].filter(Boolean).join(" · ")}</span></span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
